import { OrderTypeSelect } from "#/features/trade/components/order-form/order-type-select.tsx";
import type { useUpdateLeverage } from "#/hooks/use-trading-actions";
import type {
	MarginMode,
	OrderType,
} from "./constants/order-form.constants.ts";
import { LeverageDialog } from "./leverage-dialog.tsx";
import { MarginModeDialog } from "./margin-mode-dialog.tsx";
import type { MarginCapability } from "./utils/margin-mode.ts";

type OrderFormToolbarProps = {
	coin: string;
	marginMode: MarginMode;
	onMarginModeChange: (nextValue: MarginMode) => void;
	leverageMarks: number[];
	selectedLeverage: number;
	selectedLeverageIndex: number;
	onLeverageChange: (nextIndex: number) => void;
	maxLeverage: number;
	hasAvailableFunds: boolean;
	orderType: OrderType;
	onOrderTypeChange: (nextValue: OrderType) => void;
	updateLeverage: ReturnType<typeof useUpdateLeverage>;
	marginCapability: MarginCapability;
};

export function OrderFormToolbar({
	coin,
	marginMode,
	onMarginModeChange,
	leverageMarks,
	selectedLeverage,
	selectedLeverageIndex,
	onLeverageChange,
	maxLeverage,
	hasAvailableFunds,
	orderType,
	onOrderTypeChange,
	updateLeverage,
	marginCapability,
}: OrderFormToolbarProps) {
	return (
		<div className="trade-panel-handle flex gap-2">
			<div className={"flex flex-1 gap-2 w-full"}>
				<MarginModeDialog
					coin={coin}
					value={marginMode}
					onChange={onMarginModeChange}
					currentLeverage={selectedLeverage}
					hasAvailableFunds={hasAvailableFunds}
					updateLeverage={updateLeverage}
					marginCapability={marginCapability}
				/>

				<LeverageDialog
					coin={coin}
					value={selectedLeverage}
					selectedIndex={selectedLeverageIndex}
					leverageMarks={leverageMarks}
					maxLeverage={maxLeverage}
					marginMode={marginMode}
					supportsCrossMargin={marginCapability.supportsCrossMargin}
					hasAvailableFunds={hasAvailableFunds}
					onChange={onLeverageChange}
					updateLeverage={updateLeverage}
				/>
			</div>

			<div className={"flex-1"}>
				<OrderTypeSelect value={orderType} onValueChange={onOrderTypeChange} />
			</div>
		</div>
	);
}
